/* @flow */

import React, { useContext } from "react";
import { SuccessView as SuccessViewExt } from "@crossroads/shop-views";
import { AnalyticsContext } from "@crossroads/analytics";
import { useClient } from "entrypoint/shared";
import { OrderData } from "data";
import { useData } from "crustate/react";
import { load as loadOrder } from "state/order";
import useFormat from "helpers/use-format";
import CheckIcon from "icons/checkmark-success.svg";
import { useTranslate } from "@awardit/react-use-translate";

const SuccessView = (): React$Node => {
  const orderData = useData(OrderData);
  const { formatPrice } = useFormat();
  const gaContext = useContext(AnalyticsContext);
  const t = useTranslate();

  return (
    <SuccessViewExt
      hasRegretPurchaseButton
      orderData={orderData}
      useClient={useClient}
      analytics={gaContext}
      formatPrice={formatPrice}
      loadOrder={loadOrder}
      hasVisiblePrices={false}
      additionalField="PHONE"
      CheckIcon={<CheckIcon aria-label={t("ICONS.CHECK")} style={{ color: "#fff" }} />}
    />
  );
};

export default SuccessView;
